module.exports = __webpack_public_path__ + "manager/img/unknown.b7f6880.gif";